import React from 'react';
import { Link, useLocation } from 'react-router-dom';
export default function DCStockTransferBreadCrumbs() {
    const location = useLocation();
    const vPathName = location.pathname;
    return (
        <div className="container-fluid p-0 breadcrumb">
            {vPathName === '/DCStockTransferSummary' ? (
                <div>
                    <span className="breadcrumb-arrow-inactive">DC Stock Transfer Summary{' '}</span>
                </div>
            ) : vPathName === '/DCStockTransferDetail' ? (
                <div className="d-flex">
                    <Link
                        to="/DCStockTransferSummary"
                        state={location}
                        className={'breadcrumb-arrow-active mr-2'}>
                        DC Stock Transfer Summary
                    </Link>
                    <div>
                        <span className="breadcrumb-arrow-inactive">DC Stock Transfer Detail{' '}</span>
                    </div>
                </div>
            ) : (
                <></>
            )}
        </div>
    );
}
